import axiosClient from './axios-client';
import fauxAxiosClient from './faux-client';

const getClient = () => {
  switch (process.env.NODE_ENV) {
    case 'test':
      return fauxAxiosClient;
    default:
      return axiosClient;
  }
};

export default getClient();
